/* Usage:
 * <button data-controller='copy-to-clipboard' data-action='click->copy-to-clipboard#copy' data-copy-to-clipboard-text-param='<%= @athlete.profile_url %>' data-copy-to-clipboard-message-param='Athlete profile URL copied'>
 */
import { Controller } from "@hotwired/stimulus"
import { createAlert } from '../scripts/createAlert';

export default class extends Controller {

  copy(event) {
    const text = event.params.text;
    const message = event.params.message || "Copied!";
    const trigger = event.currentTarget || this.element;

    if (!text) {
      createAlert('danger', 'Nothing to copy');
      return;
    }

    const onSuccess = () => {
      this.hideTooltip(trigger);
      createAlert('success', message);
    };
    const onError = (err) => {
      // Fallback for environments where navigator.clipboard is unavailable/restricted
      try {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        const copied = document.execCommand('copy');
        document.body.removeChild(textarea);

        if (copied) {
          onSuccess();
        } else {
          createAlert('danger', 'Error copying text to clipboard');
        }
      } catch (fallbackError) {
        createAlert('danger', 'Error copying text to clipboard');
        console.log('Clipboard error: ', err || fallbackError);
      }
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(onSuccess, onError);
    } else {
      onError();
    }

  }

  hideTooltip(trigger) {
    if (trigger && typeof trigger.blur === "function") trigger.blur();
    if (window.bootstrap && window.bootstrap.Tooltip && trigger) {
      const tooltip = window.bootstrap.Tooltip.getInstance(trigger);
      if (tooltip) tooltip.hide();
    }
  }

}
